<template>
  <page-section
    id="vote-by-mail"
    :title="$t('cac.app.vote_by_mail')"
    class="voter-info__page-section"
  >
    <p 
      class="vote-by-mail-info" 
      v-html="voteByMailContent"/>
  </page-section>
</template>

<script>
import Icon from "StyleguideComponents/Icon.vue";

import PageSection from "CivicActionCenterComponents/shared/PageSection.vue";

export default {
  name: "VoteByMail",
  components: {
    Icon,
    PageSection
  },
  props: {
    voteByMailContent: {
      type: String,
      required: true
    }
  }
};
</script>
